/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 02.08.2016.
 */

import _get from 'lodash/get';

import {InitApplication} from "../common/actions-common";
export const GET_PARENTAL_STATE = 'get-parental-state';
export const HIDE_ADULT_CONTENT = 'hide-adult-content';
export const SHOW_ADULT_CONTENT = 'show-adult-content';
export const PIN_CHANGE = 'pin-change';

export function GetParentalState() {

  return {
    type: GET_PARENTAL_STATE,
    payload: lh.common.parental
  };
}

export function HideAdultContent(pin) {

  return {
    type: HIDE_ADULT_CONTENT,
    payload: lh.parental.hideAdultContent(pin)
  };
}

export function ShowAdultContent(pin) {

  return {
    type: SHOW_ADULT_CONTENT,
    payload: lh.parental.showAdultContent(pin)
  };
}

export function PinChange(oldPin, newPin) {

  return {
    type: PIN_CHANGE,
    payload: lh.common.request.post('/sdp/v1/parental_control/pin/change', {
      old_pin: oldPin,
      new_pin: newPin,
    }),
  };
}



// WEBPACK FOOTER //
// ./src/actions/parental/actions-parental.js